import { Link } from "react-router-dom";
import { Settings, Users, Palette, Activity, Target, BarChart3, ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/Section";
import { useI18n } from "@/context/I18nContext";

const platforms = [
  { name: "TikTok Ads", slug: "tiktok-ads-management", color: "from-pink-500/20 to-rose-600/10", dk: "ad.p1d" },
  { name: "Meta Ads", slug: "meta-ads-management", color: "from-blue-500/20 to-indigo-600/10", dk: "ad.p2d" },
  { name: "Google Ads", slug: "google-ads-management", color: "from-amber-500/20 to-yellow-600/10", dk: "ad.p3d" },
];
const capabilities = [
  { icon: Settings, k: "ad.c1" }, { icon: Activity, k: "ad.c2" }, { icon: Users, k: "ad.c3" },
  { icon: Palette, k: "ad.c4" }, { icon: Target, k: "ad.c5" }, { icon: BarChart3, k: "ad.c6" },
];

export default function Advertising() {
  const { t } = useI18n();
  return (
    <div>
      <section className="section-lux grid-glow text-center">
        <div className="container-lux max-w-3xl">
          <div className="label-lux mb-3">{t("ad.label")}</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white">{t("ad.h1a")}<span className="gold-text">{t("ad.h1b")}</span></h1>
          <p className="mt-6 text-slate-400 text-lg">{t("ad.sub")}</p>
        </div>
      </section>

      <section className="pb-6">
        <div className="container-lux grid md:grid-cols-3 gap-6">
          {platforms.map((p, i) => (
            <Link key={p.slug} to={`/services/${p.slug}`} className="card-lux p-8 fade-up" style={{ animationDelay: `${i * 70}ms` }} data-testid={`ad-platform-${p.slug}`}>
              <div className={`h-14 w-14 rounded-xl bg-gradient-to-br ${p.color} border border-white/10 mb-5`} />
              <h3 className="text-xl font-bold text-white">{p.name}</h3>
              <p className="text-sm text-slate-400 mt-3 leading-relaxed">{t(p.dk)}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-amber-400 font-medium">{t("ad.explore")} <ArrowRight size={15} /></span>
            </Link>
          ))}
        </div>
      </section>

      <section className="section-lux">
        <div className="container-lux">
          <SectionHeading label={t("ad.secLabel")} title={t("ad.secTitle")} subtitle={t("ad.secSub")} />
          <div className="mt-12 grid grid-cols-2 lg:grid-cols-3 gap-6">
            {capabilities.map((c, i) => (
              <div key={i} className="card-lux p-6 flex items-center gap-4 fade-up" style={{ animationDelay: `${i * 50}ms` }}>
                <c.icon className="text-amber-400 shrink-0" size={24} />
                <span className="font-medium text-white">{t(c.k)}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
